module.exports = __webpack_public_path__ + "img/peeli_1.4ebc8422.png";